class NamingThings {
  static buildKey(prefix,title,index=0) {
    const titleToUse = (title) ? title.split(' ').join('_').replace('*','') : 'na';
    return prefix + "_" +
      titleToUse
      + "_" + index;
  }
};

export default NamingThings;